// @flow

// Selectors
import selectedFeatures$ from 'hfty-map/src/selectors/selectedFeatures'

// Libs
import { createSelector } from 'reselect'

export default createSelector(
  [
    selectedFeatures$,
  ],
  (features: Array<Object>): Object => features
)
